import React, { useState, useEffect, useRef } from 'react';
import { Container, Row, Col, Button, Table, Form, Dropdown } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';

import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';

import pub1 from '../../../../src/assets/images/pub-1.svg';
import pub2 from '../../../../src/assets/images/pub-2.svg';
import pub3 from '../../../../src/assets/images/pub-3.svg';

import { withRFSToken } from '../../../Services/axios.js';

const ReadSign = () => {

    const storedData = JSON.parse(localStorage.getItem('RS'));
    const isMounted = useRef(false);
    const [formData, setFormData] = useState({})

    const fetcDetails = async () => {
        try {
            const res = await withRFSToken.post('document/read-sign-details-by-id', { document_id: storedData.id })
                .then(function (res) {
                    const innerData = res.data.response_data;
                    setFormData(innerData)
                });

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    useEffect(() => {
        if (isMounted.current) return;
        fetcDetails()
        isMounted.current = true;
    }, []);

    const handleChange = () => {
        if(!formData?.user_signed_permission || formData?.user_signed_permission === 0) {
            toast.warning('You do not have permission to sign');
            return;
        }
        toast.success('Signed successfully')
    }

    return (
        <>
            <div className="">
                <div className="schedule">
                    <div className='main-panel'>
                        {/* <Link to={'/ServiceRecovery'} className='stk_back'> <FontAwesomeIcon icon={faArrowLeft} /> Back</Link>
            <div className='maindiv'></div> */}

                        <div className='publication-sec my-3'>
                            <div className='publication-box-wrap'>
                                <div className='publication-box d-flex justify-content-between align-items-end'>
                                    <div className='pub-head'>
                                        <h2>Hello</h2>
                                        <h3>ID : {formData?.master_airway_bill}</h3>
                                    </div>
                                    <div className='pub-img'>
                                        <ul>
                                            <li>
                                                <a href="#" onClick={() => window.location.href = '/DocumentManagement'}><img src={pub1} alt="" /></a>
                                            </li>
                                            <li>
                                                <a href=""><img src={pub2} alt="" /></a>
                                            </li>
                                            <li>
                                                <a href=""><img src={pub3} alt="" /></a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <div className='pub-textarea'>
                                    <Form>
                                        <Form.Group className="mb-3" controlId="">
                                            <Form.Control value={formData?.content} as="textarea" placeholder='Test test test...' rows={10} readOnly />
                                        </Form.Group>
                                    </Form>
                                </div>
                                <div className='att-doc'>
                                    <h3>Attached Documents</h3>
                                    <div className='doc-dis'>
                                    </div>
                                </div>
                                <div className='readsign-wrap d-flex justify-content-end'>
                                    {formData.read_and_sign === 1 &&
                                        <>
                                            <div className='readsign'>
                                                <Form>
                                                    <div className="form-check">

                                                        <input
                                                            className="form-check-input"
                                                            type="checkbox" id="agree"
                                                            disabled={formData.user_signed === 1}
                                                            checked={formData.user_signed === 1}
                                                            onChange={() => handleChange('user_signed', 1)}
                                                        />
                                                        <label className="form-check-label" htmlFor="agree">
                                                            Read & Sign
                                                        </label>

                                                    </div>
                                                </Form>
                                                <h4>You have signed at : 09-09-2025</h4>
                                            </div>
                                        </>
                                    }
                                </div>
                                <div className='pub-ftr'>
                                    <Row className='justify-content-between'>
                                        <Col xs lg="4">
                                            <div className='pub-ref'>
                                                <ul>
                                                    <li>
                                                        <span>Ref No.</span>
                                                        <span>: {formData?.ref_no}</span>
                                                    </li>
                                                    <li>
                                                        <span>Created by</span>
                                                        <span>: {formData?.created_by}</span>
                                                    </li>
                                                    <li>
                                                        <span>Last Edited by</span>
                                                        <span>: {formData?.updated_by}</span>
                                                    </li>
                                                </ul>
                                            </div>
                                        </Col>
                                        <Col xs lg="3">
                                            <div className='pub-ref'>
                                                <ul>
                                                    <li>
                                                        <span>Version</span>
                                                        <span>: {formData?.version}</span>
                                                    </li>
                                                </ul>
                                            </div>
                                        </Col>
                                        <Col xs lg="3">
                                            <div className='pub-ref'>
                                                <ul>
                                                    <li>
                                                        <span>Last Update</span>
                                                        <span>: {formData?.updated_at}</span>
                                                    </li>
                                                    <li>
                                                        <span>Published by</span>
                                                        <span>: {formData?.created_by}</span>
                                                    </li>
                                                </ul>
                                            </div>
                                        </Col>
                                    </Row>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </>
    )
}

export default ReadSign